import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'System|Localization|Dialog';

export type SharedLocalizationLocs =
	| 'CMSystemLocalizationDialogCurrentValue'
	| 'CMSystemLocalizationDialogDefaultValue';

export const sharedLocalizationLocs: LocDefs<SharedLocalizationLocs> = {
	CMSystemLocalizationDialogCurrentValue: {
		defaultValue: 'Current Value',
		displayPath: `${dpRoot}|Current Value`,
		description:
			'Label for the current defaultValue. This is both on the string and HTML editor.',
		displayType: 'Label',
		portal: 'All',
	},
	CMSystemLocalizationDialogDefaultValue: {
		defaultValue: 'Default Value',
		displayPath: `${dpRoot}|Default Value`,
		description:
			'Label for the default defaultValue. This is both on the string and HTML editor.',
		displayType: 'Label',
		portal: 'All',
	},
};

export const SHARED_LOCALIZATION_KEYS = MapLocKeys<SharedLocalizationLocs>(sharedLocalizationLocs);
export type SharedLocType = LocMap<SharedLocalizationLocs>;
